import { Contract } from "appworks/utils/contracts/contract";
import { partnerConnectConnector } from "partner-connect/server/connectors/partner-connect-connector";
import { ForceList as Forcer } from "slotworks/debug/menu/force-list";

class PartnerConnectForcer implements Forcer {
    private results: Map<string, string> = new Map<string, string>();

    public addCheat(key: string, cheat: string) {
        this.results.set(key, cheat);
    }

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            const names: string[] = [];
            this.results.forEach((index, name) => names.push(name));
            resolve(names);
        });
    }

    public force(id: string): Contract<void> {
        return new Contract<void>((resolve) => {
            partnerConnectConnector.cheat = this.results.get(id);
            resolve(null);
        });
    }
}

export const partnerConnectForcer = new PartnerConnectForcer();
